import { Section } from "../layout/Section"

const About = () => {

  return <Section title="About">
    <p className="text-center">The name Devgroup origins from the words Development and Group, implying that we are a development group.
      Devgroup has the knowledge and skills to provide the IT-solutions you need.
      We are a serious but delightful company. We prioritise a close relationship and working process with our customer.
      Our customers is always integrated with our development process following the modern agile methodologies.</p>
  </Section>
}

export default About
